import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img1 from "../../images/services-usa/and/Why-Choose.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2><span>Why Choose</span> TekRevol as Your Startup Prototype Development Company?</h2>
                    </Col>
                </Row>
                <Row className="h-100 choose_padd">
                <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                    <p>Choosing TekRevol as your Startup Prototype Development Company guarantees a transformative journey from concept to market-ready prototype.</p>
                    <p>Our promise lies in creating innovative solutions customized to your unique vision. With an expert team skilled in ideation, design, and iteration, we bring accuracy to every phase of development.</p>
                    <p>We prioritize initial validation, aligning prototypes with strategic markers, and guaranteeing investor readiness.</p>
                    <p>Our self-motivated approach, industry expertise, and client-focused partnership differentiate us. Team up with TekRevol to experience distinction in prototype development, launching your startup towards success with front-line solutions and a devoted team passionate about bringing your ideas to life.</p>
                    <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Schedule A Free Consultation Session</Link>
                </Col>
                <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                <LazyLoadImage
                            src={Img1}
                            effect="blur" alt="tekrevol_android" className="img-fluid"
                        />
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Whychooseusa